<input
  #fileInput
  type="file"
  class="d-none"
  (change)="onFileSelect($event)"
  [id]="control().id"
  [multiple]="allowMultiple"
  [accept]="allowedFileTypes"
  [wlAutomationId]="control().options.dataAutomationId"
  aria-label="do not use"
/>
<div class="mb-0">
  <rfa-errors [control]="control()"></rfa-errors>
  <crnt-button
    class="mb-0 col-12 col-xl-auto btn-upload"
    (click)="fileInput.click(); $event.preventDefault()"
    [wlTrackFieldfocus]="focusChangeTrackConfig()"
    [attr.aria-describedby]="ariaDescribedBy()"
  >
    <crnt-icon size="large" square icon="arrow-to-top" class="me-1"></crnt-icon>
    <rfa-label [id]="control().id" [label]="control().options.label" />
  </crnt-button>

  @for (file of control().value; track $index) {
    <div
      class="d-flex align-items-center justify-content-between border-bottom"
    >
      <crnt-icon
        size="large"
        square
        [icon]="file.state === 'loading' ? 'spinner' : 'file'"
        [animation]="file.state === 'loading' ? 'spin' : undefined"
        [class.text-danger]="file.state === 'error'"
      ></crnt-icon>
      <div class="d-flex flex-column flex-grow-1 p-1 word-break">
        <span class="max-width" [class.strike]="file.state === 'error'">
          {{ file.name }}
        </span>
        <span
          class="text-body-secondary small"
          [class.strike]="file.originFile.size > maxFileSize"
        >
          {{ file.originFile.size | fileSize }}
        </span>
      </div>
      <crnt-icon-button
        class="btn-remove"
        aria-label="Remove this file"
        variant="tertiary"
        (click)="removeFile(file); $event.preventDefault()"
      >
        <crnt-icon icon="close" size="large"></crnt-icon>
      </crnt-icon-button>
    </div>
  }
</div>
